// extracted by mini-css-extract-plugin
export default {"wrapper":"jB-z","addressLine":"kB-z","fullName":"lB-z"};